DataTablesOptions = {
    responsive: true,
    paging: true,
    info: true,
    columnDefs: [{
        targets: 0,
        className: 'dt-left'
    }],
    language: {
        decimal: ",",
        thousands: ".",
        processing: "Feldolgozás...",
        search: "Keresés:",
        lengthMenu: "_MENU_ rekord mutatása",
        info: "_START_-_END_ a _TOTAL_ rekordból",
        infoEmpty: "0 bejegyzés",
        infoFiltered: "(_MAX_ rekordból szűrve)",
        infoPostFix: "",
        loadingRecords: "Betöltés...",
        zeroRecords: "Nem található rekord.",
        emptyTable: "Nincs adat ezekkel a beállításokkal!",
        paginate: {
            first: '«',
            previous: '‹',
            next: '›',
            last: '»'
        },
        aria: {
            paginate: {
                first: 'First',
                previous: 'Previous',
                next: 'Next',
                last: 'Last'
            },
        }
    },
};

